import React from 'react';
import { Star } from 'lucide-react';
type RatingStarsProps = {
  value: number;
  size?: number;
};
export function RatingStars({
  value,
  size = 14
}: RatingStarsProps) {
  return <span className="inline-flex items-center gap-0.5" aria-label={`${value} out of 5 stars`} data-id="element-548" data-mp="ntuwzzzr82jk">
      {[1, 2, 3, 4, 5].map(i => <Star key={i} size={size} aria-hidden="true" className={i <= Math.round(value) ? 'fill-amber-400 text-amber-400' : 'fill-muted text-muted-foreground/30'} data-id="element-549" data-mp="iw3535z40gfd" />)}
    </span>;
}